import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
// import './assets/css/style.css'
// import ECharts from 'vue-echarts'

// 手动引入 ECharts 各模块来减小打包体积
// import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/tooltip'

// 如果需要配合 ECharts 扩展使用，只需要直接引入扩展包即可
// 以 ECharts-GL 为例：
// 需要安装依赖：npm install --save echarts-gl，并添加如下引用
// import 'echarts-gl'

// Vue.component('v-chart', ECharts)

import moment from 'moment'
Vue.prototype.$moment = moment


Vue.config.productionTip = false;
Vue.use(ViewUI);

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('access_token')
  if(to.name !== 'login' && ! token){
    next('/login')
  }else {
    //旧版本
    // next()
    // 新版本-处理拦截路由当权限不足时，不可使用功能
    if(to.path == '/' || to.path == '/pages' || to.path == '/login' ){
        next()
    }else{
        let menus = localStorage.getItem('menus')
        const arr =JSON.parse(menus)
        var isFound = false
        if(arr == undefined || arr == null){
            if(from.path !== '/pages'){
                alert('没有权限,请重新登录'); 
                next('/pages')
            }
            return
        }
        for(var i=0; i<arr.length;i++){
            var url = arr[i].url
            if(to.path.startsWith(url)){
                isFound = true
            }
        }
        if(isFound){
            next()
        }else{
            if(from.path !== '/pages'){
                alert('没有权限,请重新登录'); 
                next('/pages')
            }
        }
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
